/**
 * AssessmentsSection — Phase 2B: toggles between the new Online Assessments
 * (scheduled/timed/auto-graded) and the classic manual score-entry grid.
 */
import { useState } from 'react';
import { CalendarClock, PenLine } from 'lucide-react';
import { Button } from '../../components/ui/button';
import AssessmentsTab from './AssessmentsTab';
import OnlineAssessmentsPanel from './OnlineAssessmentsPanel';

export default function AssessmentsSection() {
  const [mode, setMode] = useState('online');
  return (
    <div className="space-y-4" data-testid="assessments-section">
      <div className="flex gap-2">
        <Button size="sm" variant={mode === 'online' ? 'default' : 'outline'}
                onClick={() => setMode('online')} data-testid="mode-online-btn">
          <CalendarClock className="w-4 h-4 mr-1" /> Online Assessments
        </Button>
        <Button size="sm" variant={mode === 'manual' ? 'default' : 'outline'}
                onClick={() => setMode('manual')} data-testid="mode-manual-btn">
          <PenLine className="w-4 h-4 mr-1" /> Manual Scores
        </Button>
      </div>
      {mode === 'online' ? <OnlineAssessmentsPanel /> : <AssessmentsTab />}
    </div>
  );
}
